import { Environment, Plane } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import React, { useEffect, useMemo, useRef } from "react";

import { useLoader } from "@react-three/fiber";
import { useGLTFLoader } from "../dataManagers/AssetSystem3d";

const envMapPath = "/thrill-seekers-assets/textures/environment/envMap";

export default function EnvironmentController() {
  const camera = useThree(({ camera }) => camera);
  const scene = useThree(({ scene }) => scene);
  const gl = useThree(({ gl }) => gl);
  const directionalLight_ref = useRef();
  // useShadowHelper(directionalLight_ref);

  const backgroundEl = useMemo(() => {
    return document.getElementById("builder-scene-canvas-container");
  }, []);

  const gltf = useLoader(useGLTFLoader, "/thrill-seekers-assets/environment/environment.glb");

  useEffect(() => {
    scene.add(camera); // so the camera is accessible in the three.js console
    backgroundEl.style.background = "#ffffff";
    setLayerOnEnvironment();
    dispatchLoadedEvent();
  }, []);

  // set a layer so it can be hidden for the screenshot
  function setLayerOnEnvironment() {
    gltf.scene.traverse((obj) => {
      if (obj.isMesh) {
        obj.layers.set(1);
      }
    });
  }

  // signaling to the loading screen we're ready to go
  function dispatchLoadedEvent() {
    document.dispatchEvent(new CustomEvent("EnvironmentAssetsLoaded"));
  }

  return (
    <>
      {/* lighting */}
      <directionalLight
        ref={directionalLight_ref}
        args={["#fdecd8", 1]}
        position={[0, 1.5, 0.2]}
        castShadow={true}
        shadowDarkness={1}
        shadow-radius={5}
        shadow-normalBias={0.001}
        shadow-mapSize-width={512}
        shadow-mapSize-height={512}
        shadow-camera-near={0.5}
        shadow-camera-far={1.6}
        shadow-camera-left={-1}
        shadow-camera-right={1}
        shadow-camera-top={1}
        shadow-camera-bottom={-1}
      />
      <ambientLight args={["#fff", 2.5]} />

      <primitive object={gltf.scene} rotation={[0, Math.PI, 0]} />

      <Environment
        background={false}
        files={[`${envMapPath}/px.png`, `${envMapPath}/nx.png`, `${envMapPath}/py.png`, `${envMapPath}/ny.png`, `${envMapPath}/pz.png`, `${envMapPath}/nz.png`]}
        // files='/thrill-seekers-assets/environment/envMap/envMap.hdr'
        // extensions={(loader) => {
        // 	loader.setDataType(HalfFloatType)
        // }}
        // preset={'night'}
        // ground
      />

      <Plane args={[2, 2]} rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.02, 0]} receiveShadow>
        <shadowMaterial opacity={0.21} />
      </Plane>
    </>
  );
}
